<div class="tw:w-(--side-menu-width) tw:py-6 tw:bg-surface-primary">
	<div class="tw:text-center tw:pb-6">
		@if (isTest) {
			<img width="144" height="48" src="/logos/zeraki-finance-testing.svg" class="logo" alt="" />
		} @else {
			<img width="144" height="48" src="/logos/zeraki-finance.svg" class="logo" alt="" />
		}
	</div>

	<div class="tw:flex tw:flex-col tw:gap-4 tw:max-h-[calc(100dvh-100px)] tw:pb-6 tw:overflow-y-auto">
		<z-side-menu-item icon="home_work" route="/internal-views/schools">School</z-side-menu-item>

		<z-side-menu-item icon="support_agent" route="/internal-views/customer-support">Support</z-side-menu-item>

		<z-side-menu-item icon="space_dashboard" route="/internal-views/features">Features</z-side-menu-item>

		@if (userRole.isAdmin()) {
			<z-side-menu-item icon="admin_panel_settings" route="/internal-views/admin-functions">
				Admin Functions
			</z-side-menu-item>

			<z-side-menu-item icon="rule_settings" route="/internal-views/integrations" [hasSubMenu]="true">
				Integrations
				<z-sub-menu>
					<z-sub-menu-item route="/internal-views/integrations/zerakipay">
						ZerakiPay Integrations
					</z-sub-menu-item>
					<z-sub-menu-item route="/internal-views/integrations">Bank Integrations</z-sub-menu-item>
				</z-sub-menu>
			</z-side-menu-item>
		}
	</div>
</div>
